module.exports = __webpack_public_path__ + "static/media/image_12.fb2f7853.png";